import { useState, useEffect } from 'react';

const useNetwork = (): boolean => {
  const [isOnline, setIsOnline] = useState(null);
  const [mount, setIsMount] = useState(false);
  const win = mount && window ? window?.navigator?.onLine : {};
  const updateNetwork = (): void => {
    setIsOnline(window.navigator.onLine);
  };
  useEffect(() => {
    !mount && setIsMount(true);
    isOnline === null && setIsOnline(window.navigator.onLine); // need for startup
    window.addEventListener('offline', updateNetwork);
    window.addEventListener('online', updateNetwork);
    return () => {
      window.removeEventListener('offline', updateNetwork);
      window.removeEventListener('online', updateNetwork);
    };
  }, [win]);
  return isOnline;
};

export default useNetwork;
